module.exports = __webpack_public_path__ + "static/media/quindio-33.b77a1f63.jpg";